<template>
  <div>
    <Modal
      v-model="appointModal"
      title="指派"
      @on-cancel="cancelModal">
      <Form :model="form" :label-width="70" ref="form" :rules="validRule">
        <FormItem label="归类" prop="type">
          <Select v-model="form.type" @on-change="handleTypeOnChange" placeholder="请选择指派目标问题分类">
            <Option v-for="item in workSheetTypeList" :key="item.id" :value="item.id" :label="item.type_name"></Option>
          </Select>
        </FormItem>
        <FormItem label="问题子类" prop="sonType">
          <Select v-model="form.sonType" placeholder="请选择转接目标问题子类">
            <Option v-for="item in workSheetTypeListSon" :key="item.id" :value="item.id" :label="item.type_name"></Option>
          </Select>
        </FormItem>
        <FormItem label="截止日期" prop="deadline">
          <DatePicker v-model="form.deadline"  type="date" style="width:100%;" format="yyyy-MM-dd"></DatePicker>
        </FormItem>
        <FormItem label="指派用户" prop="user_id">
           <Select v-model="form.user_id" placeholder="请选择指派目标用户" clearable filterable>
            <Option v-for="item in all_user_list" :key="item.key" :value="item.key" :label="item.label"></Option>
          </Select>
        </FormItem>
         <FormItem label="指派组" prop="group_id">
           <Select v-model="form.group_id" placeholder="请选择指派目标组" clearable filterable>
            <Option v-for="item in all_group_list" :key="item.key" :value="item.key" :label="item.label"></Option>
          </Select>
        </FormItem>
        <FormItem label="备注" prop="remark">
          <Input type="textarea" v-model="form.remark" placeholder="最大200个字符" :maxlength="200" />
        </FormItem>
      </Form>
      <div slot="footer">
        <Button :loading="submitLoading" type="primary" @click="ok">提交</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { GetALLWorkSheetType, GetALLWorkSheetTypeSon } from '@/api/logistics/type'
import { GetWSAllUser, AppointApi, GetWSAllGroup } from '@/api/logistics/worksheet'
import eventVue from './event.js'
// import dayjs from 'dayjs'
import moment from 'moment'
import { GetALLUsers, getAllGroup } from '@/api/user'

export default {
  name: 'appoint',
  data () {
    return {
      all_user_list: [],
      all_group_list: [],
      appointModal: false,
      submitLoading: false,
      form: {
        id: '',
        type: '',
        sonType: '',
        user_id: '',
        group_id: '',
        deadline: '',
        remark: ''
      },
      workSheetTypeList: [],
      workSheetTypeListSon: [],
      userList: [],
      groupList: [],
      validRule: {
        deadline: { required: true, type: 'date', message: '请选择截止时间', trigger: 'change' }
      }
    }
  },
  created: function () {
    this.getWorkSheetAllTypeList()
  },
  methods: {
    ok () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          console.log(this.form)
          if (this.form.user_id || this.form.group_id) {
            // this.form.deadline = this.form.deadline === '' ? '' : this.form.deadline.getFullYear() + '-' + (this.form.deadline.getMonth() + 1) + '-' + this.form.deadline.getDate()
            // this.form.deadline = dayjs(this.form.deadline).format('YYYY-MM-DD')
            this.form.deadline = moment(this.form.deadline).format('YYYY-MM-DD')
            this.submitLoading = true
            let data = JSON.parse(JSON.stringify(this.form))
            AppointApi(data).then(res => {
              const result = res.data
              if (result.code === 200) {
                this.$Notice.success({
                  title: '操作成功！'
                })
                eventVue.$emit('myFun', {})
                this.cancelModal()
                this.appointModal = false
              } else {
                this.$Notice.error({
                  title: '操作失败',
                  desc: result.msg
                })
              }
              this.submitLoading = false
            }).catch(_ => {
              this.submitLoading = false
            })
          } else {
            this.$Notice.error({
              title: '操作失败',
              desc: '请填指派用户或者指派组'
            })
          }
        }
      })
    },
    cancelModal () {
      this.form.id = ''
      this.form.user_id = ''
      this.form.group_id = ''
      this.form.remark = ''
      this.form.type = ''
      this.form.sonType = ''
      this.form.deadline = ''
      this.userList = []
    },
    show (row) {
      console.log(row)
      this.form.id = row.id
      if (row.type) {
        // this.getUserList(row.type.id)
        // this.getGroupList(row.type.id)
        this.getAllUsersData()
        this.getAllGroupsData()
        this.getWorkSheetAllTypeListSon(row.type.id)
        this.form.type = row.type.id
        this.form.sonType = row.son_type ? row.son_type.id : ''
        this.form.deadline = row.deadline === null ? null : new Date(row.deadline)
        this.form.user_id = row.operator === null ? null : row.operator.id
        this.form.group_id = row.operator_group === null ? null : row.operator_group.id
      }
      this.appointModal = true
    },
    getWorkSheetAllTypeList () {
      GetALLWorkSheetType().then(res => {
        this.workSheetTypeList = res.data
      })
    },
    getWorkSheetAllTypeListSon (typeId) {
      this.workSheetTypeListSon = []
      this.form.sonType = ''
      let params = {
        parent_id: typeId
      }
      GetALLWorkSheetTypeSon(params).then(res => {
        this.workSheetTypeListSon = res.data
      })
    },
    getUserList (typeId) {
      this.form.user_id = ''
      this.userList = []
      if (typeId) {
        const params = {
          ws_type__id: typeId
        }
        GetWSAllUser(params).then(res => {
          this.userList = res.data
        })
      }
    },
    getGroupList (typeId) {
      this.form.group_id = ''
      this.groupList = []
      if (typeId) {
        const params = {
          ws_type__id: typeId
        }
        GetWSAllGroup(params).then(res => {
          this.groupList = res.data
        })
      }
    },
    handleTypeOnChange (typeId) {
      // 取当前大类的子类
      if (typeId) {
        this.getWorkSheetAllTypeListSon(typeId)
      }
      // 取到用户
      // this.getUserList(typeId)
      // // 取到组
      // this.getGroupList(typeId)
    },
    // 获取所有客服列表
    getAllUsersData () {
      this.all_user_list = []
      GetALLUsers().then(res => {
        let result = res.data
        for (let i in result) {
          this.all_user_list.push({ key: result[i].id, label: result[i].name })
        }
      })
    },
    // 获取所有分组列表
    getAllGroupsData () {
      this.all_group_list = []
      getAllGroup().then(res => {
        let result = res.data
        for (let i in result) {
          if (result[i].name.indexOf('工单') > -1) {
            this.all_group_list.push({ key: result[i].id, label: result[i].name })
          }
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
